<div class="container-fluid">
  <div class="row">
    <div class="col-sm-12 tablet-scn">
      <div class="card">
        <div class="card-header f-light" [style.padding]="headerPadding">
          <div class="d-flex justify-content-between align-items-center tablet-scn-header">
            <h5>{{ tableTitle }}</h5>
            <div class="d-flex gap-2 search-feild mb-2">
              <div class="input-group search-menu" style="width: 300px;" tabindex="1" *ngIf="isSearch" (focusout)="onInputBlur()">
                <input type="text" class="form-control" placeholder="Search" [(ngModel)]="searchText" (keyup)="onKeyUp($event, 'common')" (focus)="onInputFocus()">
                <button class="btn search-button" (mousedown)="$event.preventDefault();" [ngClass]="{'enable': searchText || isEnable}" [disabled]="!isEnable" type="button" (click)="onSearch($event)">
                  <i class="fa fa-search"></i>
                </button>
              </div>
              <button class="btn btn-primary" type="button" (click)="onButtonClick()" *ngIf="istableBtnShow && canCreate(page_id)&& screenWidth >= 600">{{tableButton}}</button>
            </div>
          </div>
          <div *ngIf="tableType === 'rent_order'" tabindex="1" (focusout)="onInputBlur()" class="rent-order d-flex">
            <div class="search-feild-group">
              <div class="input-group search-menu col">
                <input type="text" class="form-control" placeholder="Search order id" [(ngModel)]="orderId" (keyup)="onKeyUp($event, 'order')" (focus)="onInputFocus()">
              </div>
              <div class="input-group search-menu col">
                <input type="date" class="form-control" title="Search book date" [(ngModel)]="bookDate" (ngModelChange)="onDateChange($event, 'bookDate')" (focus)="onInputFocus()">
              </div>
              <div class="input-group search-menu col">
                <input type="date" class="form-control" placeholder="Search return date" [(ngModel)]="returnDate" (ngModelChange)="onDateChange($event, 'returnDate')" (focus)="onInputFocus()">
              </div>
              <div class="input-group search-menu col">
                <input type="text" class="form-control" placeholder="Search customer name" [(ngModel)]="name" (keyup)="onKeyUp($event, 'order')" (focus)="onInputFocus()">
              </div>
              <div class="input-group search-menu col">
                <select class="form-control" [(ngModel)]="status" (focus)="onInputFocus()">
                  <option value="" selected disabled>Select status</option>
                  <option *ngFor="let statusOption of status_for_rentorder" [value]="statusOption">{{ statusOption }}</option>
                </select>
              </div>
            </div>
            <button class="btn search-button" (mousedown)="$event.preventDefault();" [ngClass]="{'enable': (orderId || bookDate || returnDate || isEnable)}" [disabled]="!isEnable"  type="button" (click)="onRentSearch()">
              <i class="fa fa-search"></i>
            </button>
          </div>
          <div  *ngIf="['income', 'expense'].includes(tableType)" tabindex="1" (focusout)="onInputBlur()" class="search-by-date inc-exp-search d-flex pt-3 ">
            <div class="dateSearch">
              <div class="input-group search-menu">
                <input type="date" class="form-control" placeholder="search income date" [(ngModel)]="date" (ngModelChange)="onDateChange($event, 'date')" (focus)="onInputFocus()">
              </div>
              <div class="search-main">
                <button class="btn search-button" (mousedown)="$event.preventDefault();" [ngClass]="{'enable': (date || isEnable) }" [disabled]="!isEnable"  type="button" (click)="onDateSearch()">
                  <i class="fa fa-search"></i>
                </button>
              </div>
            </div>
            <div class="totalAmount">
              <b>Total Amount : <span>{{ totalAmount }}</span></b>
            </div>
          </div>
        </div>
      
        <div class="card-body pt-3 custom-datatable noscroll" >
          <div class="custom-datatable table-responsive" >
            <div class="table-scrollable-x">
              <table class="table">
                <thead>
                  <tr>
                    <th [ngClass]="{'text-center': tableTitle === 'Lead List' || tableTitle === 'Rent Order List'}"  *ngIf="showActions && ([15,2,6,7].includes(page_id) || canAction(page_id)) && screenWidth < 600">Actions</th>
                    <th scope="col">S.No.</th> 
                    <th *ngFor="let header of tableHeaders" scope="col">{{  header.label }}</th>
                    <th *ngIf="tableTitle === 'Return Products List' && ([4].includes(page_id) || canAction(page_id)); else noAction">Actions</th>
                    <th *ngIf="tableTitle === 'Available'">Product Image</th>
                    <th *ngIf="tableTitle === 'Available'">Book Now</th>
                    <th *ngIf="tableTitle === 'Organization List'|| tableTitle === 'Staff List'">Block/Unblock</th>
                    <th *ngIf="tableTitle === 'Store List'">Store Image</th>
                    <th [ngClass]="{'text-center': tableTitle === 'Lead List' || tableTitle === 'Rent Order List'}"   *ngIf="(showActions && ([15,2,6,7].includes(page_id) || canAction(page_id)) && screenWidth >= 600);else noAction">Actions</th>
                    <ng-template #noAction>
                      <th *ngIf="(!showActions || !([15,2,6,7].includes(page_id) || canAction(page_id)))&&page_id !== 16"></th>
                    </ng-template>
                  </tr>
                </thead> 
                <tbody>
                  <ng-container>
                    <tr *ngFor="let item of tableItems let i = index">
                      <td *ngIf="showActions && screenWidth < 600">
                        <div class="action" [ngClass]="{'lead-list-exclude': tableTitle === 'Lead List'}">
                          <ul [ngClass]="{'rent-order-exclude': tableTitle === 'Rent Order List'}">
                            <li  style="width: 28px;" class="edit" *ngIf="(tableTitle === 'Rent Order List' && item.status === 'RETURNED')"></li>
                            <li class="edit" *ngIf="tableTitle !== 'Washing List' && !(tableTitle === 'Rent Order List' && item.status === 'RETURNED') && canEdit(page_id)">
                              <a [title]="'Edit'"><i class="icon-pencil-alt" (click)="onEditItem(item)"></i></a>
                            </li>
                            <li class="delete" (click)="onDeleteItem(item)" *ngIf="tableTitle !== 'Washing List' && canDelete(page_id)">
                              <a [title]="'Delete'"><i class="icon-trash" ></i></a>
                            </li>
                            <li class="return return-product-hidden" *ngIf="(tableTitle === 'Rent Order List' && item.status === 'RETURNED' && showActions)"></li>
                            <li class="return return-product" (click)="returnItem(item)" *ngIf="showActions && tableTitle === 'Rent Order List'">
                              <a [title]="'Return'" class="hand-icon" *ngIf="item.status !== 'RETURNED' && item.remaining_amount != 0">
                                <svg class="icon return-product" width="30" height="18" viewBox="0 0 28 30" xmlns="http://www.w3.org/2000/svg">
                                  <use xlink:href="assets/svg/icon-sprite.svg#return-box"></use>
                                </svg>
                              </a>
                            </li>     
                            <li class="return" (click)="returnProduct(item)" *ngIf="showActions && tableTitle === 'Buy Back Product List'">
                              <a [title]="'Return'" class="hand-icon">
                                <svg class="icon return-product" width="30" height="18" viewBox="0 0 28 30" xmlns="http://www.w3.org/2000/svg" style="margin-right: 12px;">
                                  <use xlink:href="assets/svg/icon-sprite.svg#return-box"></use>
                                </svg>
                              </a>
                            </li>                                                         
                            <li class="view text-center" (click)="OnViewItem(item)" *ngIf="tableTitle === 'Rent Order List'">
                              <a [title]="'View'"><i class="icon-eye"></i></a>
                            </li>
                            <li class="view text-center" (click)="OnPrintItem(item, 'whatsapp')" *ngIf="tableTitle === 'Rent Order List' ">
                              <a [title]="'View'"><i class="fab fa-whatsapp" style="color: #39AE41;"></i></a>
                            </li> 
                            <li class="view text-center" (click)="OnPrintItem(item, 'printItem')" *ngIf="tableTitle === 'Rent Order List' ">
                              <a [title]="'View'"><i class="icon-printer"></i></a>
                            </li> 
                            <li *ngIf="tableTitle === 'Washing List'"><button type="button" class="btn btn-primary" (click)="returnList(item)">Return</button></li>
                            <li *ngIf="tableTitle === 'Lead List'">
                              <a [title]="'Follow Up'"><i class="icon-user" (click)="followUp(item)"></i></a>
                              <a [title]="'View'"><i class="icon-eye" (click)="viewHistory(item)"></i></a>
                            </li>
                          </ul>
                        </div>
                      </td>
                      <td [style.width.%]="'8'">{{ (currentPage - 1) * pageSize + i + 1 }}</td>
                      <ng-container  *ngFor="let header of tableHeaders">
                        <td *ngIf="header.key !== 'expired_at' && header.key !== 'dob' && header.key !== 'function_date' && header.key !== 'book_date' && header.key !== 'return_date' && header.key !== 'date' && header.key !== 'returnDate'" [style.width.%]="header.width">{{ item[header.key] || '-' }}</td>
                        <td *ngIf="header.key === 'expired_at' || header.key === 'dob' || header.key === 'function_date' || header.key === 'book_date' || header.key === 'return_date' || header.key === 'date' || header.key === 'returnDate'" id="demo099" [ngClass]="{'red-color': item.is_expire }" [style.width.%]="header.width">{{ item[header.key] | dateFormate }}</td>
                      </ng-container>
                      <td *ngIf="tableTitle === 'Return Products List'">
                        <button class="btn btn-primary" (click)="washForm(item)">Move to Washing</button>
                      </td>
                      <td *ngIf="tableTitle === 'Available'">
                        <img *ngIf="item.product_image" [src]="baseUrl + item.product_image" alt="No Image" width="100" height="100" (click)="openImageModal(baseUrl + item.product_image)" class="clickable-image">
                        <span *ngIf="!item.product_image">No Image Available</span>
                      </td>
                      <td *ngIf="tableTitle === 'Available'">
                        <button class="btn btn-primary" (click)="navigateToAddOrder(item)">Book Now</button>
                      </td>
                      <td *ngIf="tableTitle === 'Store List'">
                        <img *ngIf="item.image" [src]="baseUrl + item.image" alt="No Image" width="100" height="100" (click)="openImageModal(baseUrl + item.image)" class="clickable-image" (click)="openImageModal(baseUrl + item.image)" class="clickable-image">
                        <span *ngIf="!item.image">No Image Available</span>
                      </td> 
                      <td *ngIf="tableTitle === 'Organization List'|| tableTitle === 'Staff List'">
                        <button class="btn" [ngClass]="{'btn-danger': item?.is_active, 'btn-success': !item?.is_active}" (click)="onStatusChange(item)">{{ item?.is_active ? 'Block' : 'Unblock' }}</button>
                      </td> 
                      <td *ngIf="showActions && screenWidth >= 600">
                        <div class="action" [ngClass]="{'lead-list-exclude': tableTitle === 'Lead List'}">
                          <ul [ngClass]="{'rent-order-exclude': tableTitle === 'Rent Order List'}">
                            <li  style="width: 28px;" class="edit" *ngIf="(tableTitle === 'Rent Order List' && item.status === 'RETURNED')"></li>
                            <li class="edit" *ngIf="tableTitle !== 'Washing List' && !(tableTitle === 'Rent Order List' && item.status === 'RETURNED') && canEdit(page_id)">
                              <a [title]="'Edit'"><i class="icon-pencil-alt" (click)="onEditItem(item)"></i></a>
                            </li>
                            <li class="delete" (click)="onDeleteItem(item)" *ngIf="tableTitle !== 'Washing List' && canDelete(page_id)">
                              <a [title]="'Delete'"><i class="icon-trash" ></i></a>
                            </li>
                            <li class="return return-product-hidden" *ngIf="(tableTitle === 'Rent Order List' && item.status === 'RETURNED' && showActions)"></li>
                            <li class="return return-product" (click)="returnItem(item)" *ngIf="showActions && tableTitle === 'Rent Order List'">
                              <a [title]="'Return'" class="hand-icon" *ngIf="item.status !== 'RETURNED' && item.remaining_amount != 0">
                                <svg class="icon return-product" width="30" height="18" viewBox="0 0 28 30" xmlns="http://www.w3.org/2000/svg">
                                  <use xlink:href="assets/svg/icon-sprite.svg#return-box"></use>
                                </svg>
                              </a>
                            </li>     
                            <li class="return" (click)="returnProduct(item)" *ngIf="showActions && tableTitle === 'Buy Back Product List'">
                              <a [title]="'Return'" class="hand-icon">
                                <svg class="icon return-product" width="30" height="18" viewBox="0 0 28 30" xmlns="http://www.w3.org/2000/svg" style="margin-right: 12px;">
                                  <use xlink:href="assets/svg/icon-sprite.svg#return-box"></use>
                                </svg>
                              </a>
                            </li>                                                         
                            <li class="view text-center" (click)="OnViewItem(item)" *ngIf="tableTitle === 'Rent Order List'">
                              <a [title]="'View'"><i class="icon-eye"></i></a>
                            </li>
                            <li class="view text-center" (click)="OnPrintItem(item, 'whatsapp')" *ngIf="tableTitle === 'Rent Order List' ">
                              <a [title]="'View'"><i class="fab fa-whatsapp" style="color: #39AE41;"></i></a>
                            </li> 
                            <li class="view text-center" (click)="OnPrintItem(item, 'printItem')" *ngIf="tableTitle === 'Rent Order List' ">
                              <a [title]="'View'"><i class="icon-printer"></i></a>
                            </li> 
                            <li *ngIf="tableTitle === 'Washing List'"><button type="button" class="btn btn-primary" (click)="returnList(item)">Return</button></li>
                            <li *ngIf="tableTitle === 'Lead List'">
                              <a [title]="'Follow Up'"><i class="icon-user" (click)="followUp(item)"></i></a>
                              <a [title]="'View'"><i class="icon-eye" (click)="viewHistory(item)"></i></a>
                            </li>
                          </ul>
                        </div>
                      </td>
                      <td *ngIf="(!showActions || !([15,2,6,7].includes(page_id) || canAction(page_id)))&& page_id !== 16"></td>      
                      <th *ngIf="page_id===5"></th> 
                    </tr>
                  </ng-container>
                  <tr *ngIf="tableItems?.length <= 0">
                     <td colspan="100%" class="noFound">No data Found</td>
                  </tr>
                </tbody>  
                <button class="btn btn-primary add-plus" type="button" (click)="onButtonClick()" *ngIf="istableBtnShow && canCreate(page_id) && screenWidth < 600">
                  <img src="./assets/svg/plus.svg" alt="">
               </button>
              </table>
            </div>
            <div class="d-flex justify-content-between mt-3 isPagination" *ngIf="isPagination">
              <select class="form-select" style="width: auto" [(ngModel)]="pageSize" name="pageSize" (change)="onPageSizeChange($event.target.value)">
                <option *ngFor="let option of pageSizeOptions" [value]="option">{{ option }} items per page</option>
              </select>
              <ngb-pagination
                [collectionSize]="totalCount"
                [(page)]="currentPage"
                [pageSize]="pageSize"
                (pageChange)="onPageChange($event)"
                [boundaryLinks]="true"
                [directionLinks]="true"
                [ellipses]="false"
                [maxSize]="5"
                previousLabel="Previous"
                nextLabel="Next"
              ></ngb-pagination>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<app-image-modal [imageUrl]="selectedImage" [isVisible]="isModalVisible"(onClose)="closeImageModal()"></app-image-modal>       